export const SET_PAYMENT_CONFIG = 'SET_PAYMENT_CONFIG';
export const CHANGE_PAYMENT_TYPE = 'CHANGE_PAYMENT_TYPE';
export const VALIDATE_PAYMENT = 'VALIDATE_PAYMENT';
export const VALIDATE_PAYMENT_FAIL = 'VALIDATE_PAYMENT_FAIL';
export const INIT_PAYMENT = 'INIT_PAYMENT';
export const INIT_SOLID_PAYMENT = 'INIT_SOLID_PAYMENT';
export const SET_BANKCARD_SRC = 'SET_BANKCARD_SRC';
export const INIT_BANK_CARD = 'INIT_BANK_CARD';
export const INIT_PAY_PAL = 'INIT_PAY_PAL';
export const VALIDATE_PAYMENT_DATA = 'VALIDATE_PAYMENT_DATA';
export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA';
export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT';
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
export const SET_ORDER_ID = 'SET_ORDER_ID';
export const SET_SUBSCRIPTION_ID = 'SET_SUBSCRIPTION_ID';
export const SET_PAYMENT_CURRENCY = 'SET_PAYMENT_CURRENCY';
export const SET_EXCLUSIVE_OFFER = 'SET_EXCLUSIVE_OFFER';
export const SET_PAYMENT_TYPE = 'SET_PAYMENT_TYPE';
export const INIT_ONE_CLICK_PAYMENT = 'INIT_ONE_CLICK_PAYMENT';
export const SET_UPSELL_PRODUCT_PRICE = 'SET_UPSELL_PRODUCT_PRICE';
export const SET_UPSELL_PRODUCT_ID = 'SET_UPSELL_PRODUCT_ID';
export const SET_PAYMENT_DISCOUNT = 'SET_PAYMENT_DISCOUNT';
export const SET_IS_PAYMENT_SCREEN = 'SET_IS_PAYMENT_SCREEN';
export const SET_CUSTOM_PAYMENT_BUTTON = 'SET_CUSTOM_PAYMENT_BUTTON';
export const SET_HIDE_CUSTOM_PAYMENT_BUTTON = 'SET_HIDE_CUSTOM_PAYMENT_BUTTON';
export const SET_IS_LOADING_BANK_CARD = 'SET_IS_LOADING_BANK_CARD';
export const SET_MERCHANT_DATA = 'SET_MERCHANT_DATA';
export const INIT_PAYMENT_GENERATOR = 'INIT_PAYMENT_GENERATOR';
export const SET_IS_APPLE_PAY_AVAILABLE = 'SET_IS_APPLE_PAY_AVAILABLE';
export const INIT_BRAIN_TREE = 'INIT_BRAIN_TREE';
export const SET_PAYMENT_RETENO_ERROR = 'SET_PAYMENT_RETENO_ERROR';
export const SET_PAYMENT_RETENO_ERROR_STORE = 'SET_PAYMENT_RETENO_ERROR_STORE';
export const SET_SKIP_TRIAL_PRODUCT = 'SET_SKIP_TRIAL_PRODUCT';
export const SKIP_TRIAL_SUBSCRIPTION = 'SKIP_TRIAL_SUBSCRIPTION';
export const SET_ALL_PRODUCTS_FROM_FIRST_PAYMENT = 'SET_ALL_PRODUCTS_FROM_FIRST_PAYMENT';
export const SET_IS_GOOGLE_PAY_AVAILABLE = 'SET_IS_GOOGLE_PAY_AVAILABLE';
export const SET_IS_LATAM_ON = 'SET_IS_LATAM_ON';
export const SET_IS_UPSELL_PAID = 'SET_IS_UPSELL_PAID';
export const SET_IS_UPSELL_SUB_PAID = 'SET_IS_UPSELL_SUB_PAID';
export const SET_GUIDES_PRODUCT = 'SET_GUIDES_PRODUCT';
export const SET_PAGE_TYPE = 'SET_PAGE_TYPE';
export const HANDLE_SUCCESS_ONE_CLICK_PAYMENT = 'HANDLE_SUCCESS_ONE_CLICK_PAYMENT';
export const GET_MERCHANT_DATA = 'GET_MERCHANT_DATA';
export const SET_MERCHANT_DATA_UPSELL = 'SET_MERCHANT_DATA_UPSELL';
export const GET_MERCHANT_DATA_UPSELL = 'GET_MERCHANT_DATA_UPSELL';
